<div class="profile-authentication-area ptb-70 mt-5 ">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="login-form animate_animated animate_fadeIn"><br>
                    <h2> Iniciar Sesión </h2>
                    <form [formGroup]="loginForm"
                          (ngSubmit)="login()">

                        <div class="form-group">
                            <label>Email</label>
                            <input formControlName="email"
                                   type="email"
                                   class="form-control text-lowercase"
                                   placeholder="Ingrese su correo electrónico"
                                   [class.is-invalid]="emailAccess">
                            <small *ngIf="emailAccess"
                                   class="text-danger">Ingrese su correo electrónico</small>
                        </div>

                        <div class="form-group inner-addon right-addon">
                            <label>Contraseña</label>
                            <div class="input-group">
                                <input formControlName="password"
                                       [type]="showPasswordLogin ? 'text' : 'password'"
                                       class="form-control"
                                       placeholder="Ingrese su contraseña"
                                       [class.is-invalid]="passwordAccess">
                                <i alt="show"
                                   class="far fa-eye eye-show"
                                   (click)="showPasswordLogin = !showPasswordLogin"
                                   [class.hide]="showPasswordLogin"></i>
                                <i alt="hide"
                                   class="far fa-eye-slash eye-hide"
                                   (click)="showPasswordLogin = !showPasswordLogin"
                                   [class.hide]="!showPasswordLogin"></i>
                            </div>
                            <small *ngIf="passwordAccess"
                                   class="text-danger">Ingrese su contraseña</small>
                        </div>
                        <div class="row align-items-center">
                            <!-- <div class="col-lg-6 col-md-6 col-sm-6 remember-me-wrap">
                                <p>
                                    <input type="checkbox"
                                           id="test2">
                                    <label for="test2">Recordarme</label>
                                </p>
                            </div> -->
                            <div class="col-12 lost-your-password-wrap">
                                <!-- <a routerLink="/resend-pin"
                                   class="lost-your-password"
                                   style="text-decoration: none;">Reenviar PIN</a> --> 
                                    <a routerLink="/reset-password"
                                   class="lost-your-password"
                                   style="text-decoration: none;">Olvidé mi contraseña</a>
                                    <!-- - <a
                                   routerLink="/activate-account"
                                   class="lost-your-password"
                                   style="text-decoration: none;">Activar cuenta mediante PIN</a> -->
                            </div>
                        </div>

                        <button type="submit"
                                [disabled]="!loginForm.valid"
                                disabled><i class="fas fa-sign-in-alt"></i> Iniciar Sesión</button>
                        <button type="submit"
                                *ngIf="loadingForm"
                                [disabled]="true"
                                class="btn btn-primary submit-btn btn-block">
                            <i class="fas fa-sign-in-alt"></i>
                            Ingresando al sistema
                        </button>
                    </form>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 right-container">
                <img src="assets/img/sliders/modern_login_bg.png" alt="image" class="slider-image">
            </div>
        </div>
    </div>
</div>